import {PriorityIcon} from '@priority-software/priority-style-react';
import error from '../../../images/error.png';

export enum messageType {
    info,
    confirm,
    error,
    none
}
export const typeToIcon = {
    [messageType.info]: PriorityIcon.moreInfo,
    [messageType.confirm]: PriorityIcon.attention
};

export const typeToPng = {
    [messageType.error]: error
};

export const messagesIds = {
    screens: {
        onOpenIsDirtyWarn: 'screenOnOpenIsDirty',
        onCloseChangedConfirm: 'screensOnCloseChange',
        onCloseWarn: 'screensOnClose',
        changeFieldTitleWarn: 'ScreensFieldChangeTitleWarn',
        changeFieldTitleConfirm: 'ScreensFieldChangeTitleConfirm',
        saveContainerNoTitleWarn: 'screensFieldSaveContainerWarn1',
        saveContainerWarn: 'screensFieldSaveContainerWarn2',
        saveDataWarn: 'ScreensSaveDataWarn',
        saveDataChangedPackagesWarn: 'screensSaveDataChangedPackagesWarn',
        systemReportsFieldHiddenWarn: 'ScreensSystemReportsFieldHidden',
        noTitleWarn: 'screensNoTitleWarns',
        duplicatetitleWarn: 'screensDuplicatetitleWarn',
        runPackagesConfirms: 'screensRunPackagesConfirms',
        deleteContainerconfirm: 'screensDeleteContainerconfirm',
        restoreDefaultsvalueConfirm: 'screensRestoreDefaultsvalueConfirm',
        changeScreenConfirm: 'screensChangeScreenConfirm',
        showHiddenItemWarn: 'screensShowHiddenItemWarn',
        restoreReportTabConfirm: 'screensRestoreReportTabConfirm',
        deleteReportTabConfirm: 'screensDeleteReportTabConfirm',
        deleteTemplateConfirm: 'screensDeleteTemlpateConfirm',
        createTemplateWarn: 'screensCreateTemplateWarn',
        changeTemplateTitleConfirm: 'changeTemplateTitleConfirm',
        ctrlZConfirm: 'ctrlZConfirm',
        about: 'about',
        templateLangChange: 'templateLangChange'
    },
    searches: {
        afterSaveNewSearch: 'searchesAfterSaveNewSearch',
        onShowHelp: 'searchesonShowhelp',
        deleteSavedItem: 'searchDelteSavedItem',
        pasteWarn: 'searchPasteWarn'
    }
};

export const installpage = '_installpage=1';
